// Add a method to Array prototype to get a random element
Array.prototype.getRandomElement = function () {
  if (this.length === 0) return null; // Return null if the array is empty
  const randomIndex = Math.floor(Math.random() * this.length);
  return this[randomIndex];
};
String.prototype.getCDNUrl = function () {
  if (!this) {
    throw new Error("Base URL is required.");
  }

  return `${window.APP_CONFIG.cdnurl}/${this}`;
};
